"use client";
import React from "react";

export default function WorkflowSteps({ userType, description, steps }) {
  return (
    <div className="w-full flex flex-col items-center gap-12 md:gap-[72px]">
      {/* Section Header */}
      <div className="w-full flex flex-col items-center gap-8 px-6">
        <div className="text-center">
          <div className="text-2xl md:text-3xl lg:text-[36px] leading-tight lg:leading-[36px] font-medium text-black">
            <span>How Hyrelancer Works for </span>
            <span className="text-[#3a599c]">Freelancer</span>
          </div>
        </div>
        <div className="max-w-[616px] text-center text-sm md:text-base leading-6 text-black">
        Finding the right clients has never been simpler.
        Our platform makes it easy for skilled individuals to showcase their talent, connect with genuine opportunities, and grow their income  quickly, confidently, and securely.
        </div>
      </div>

      {/* Steps */}
      <div className="w-full flex flex-col gap-20 md:gap-28">
        {steps.map((step, index) => (
          <div 
            key={index}
            className={`w-full flex flex-col ${
              index % 2 === 0 
                ? 'xl:flex-row' 
                : 'xl:flex-row-reverse bg-[#f4f4f4]'
            } items-center justify-between gap-8 md:gap-12 ${
              index % 2 === 0 ? '' : 'py-12'
            } px-6 md:px-12 lg:px-36`}
          >
            <div className={`w-full ${index === 2 ? 'lg:w-[660px]' : 'lg:w-[662px]'} flex flex-col gap-12 md:gap-[72px] relative`}>
              <div className="absolute right-0 top-0 text-[200px] md:text-[300px] font-bold text-gray-300 opacity-30 pointer-events-none select-none leading-none z-0">
                {index + 1}
              </div>
              <div className="flex flex-col relative z-10">
                <p className="m-0 text-2xl md:text-3xl lg:text-[30px] leading-tight lg:leading-[36px] font-medium text-black">
                  {step.title}
                </p>
                <p className="m-0 text-sm md:text-base leading-6 font-semibold text-black">
                  {step.subtitle}
                </p>
              </div>
              <div className="text-sm md:text-base leading-6 text-black relative z-10">
                {step.description.map((paragraph, pIndex) => (
                  <p key={pIndex} className="m-0">
                    {paragraph || '\u00A0'}
                  </p>
                ))}
              </div>
            </div>
            <img 
              className="w-full h-auto max-w-full sm:max-w-[400px] md:max-w-[500px] lg:max-w-[550px] xl:max-w-[600px] 2xl:max-w-[796px] rounded-2xl object-cover" 
              src={step.image} 
              alt={step.alt || `Step ${index + 1}`} 
            />
          </div>
        ))}
      </div>
    </div>
  );
}